import { useQuery } from '@tanstack/react-query';
import { useEmoji } from './queries';

export interface EmojiEntry {
  hexcode: string;
  label: string;
  unicode: string;
}

async function loadEmojibase(): Promise<EmojiEntry[]> {
  const res = await fetch('/emojibase.json');
  if (!res.ok) throw new Error(`emojibase: ${res.status}`);
  return res.json();
}

/**
 * Emoji catalog for the picker: emojibase labels intersected with the set the
 * backend can actually render (so a chosen emoji is guaranteed to appear in PDFs).
 */
export function useEmojiCatalog() {
  const known = useEmoji();
  const base = useQuery({
    queryKey: ['emojibase'],
    queryFn: loadEmojibase,
    staleTime: Infinity,
  });

  const ready = known.data && base.data;
  const entries = ready
    ? base.data!.filter((e) => known.data!.includes(e.unicode))
    : [];

  return {
    entries,
    isLoading: known.isLoading || base.isLoading,
    isError: known.isError || base.isError,
  };
}
